import { Typewriter } from 'react-simple-typewriter';
import bgVideo from '../../../Assets/Videos/bgVid.mp4';
import { GasPriceCom } from '../../../Components';
import './MainHeaderSec.css';




const MainHeaderSec = () => {


    return (
        <div className='MainHeaderSec'>
            <video src={bgVideo} 
                autoPlay 
                loop 
                muted 
                className='bg-video'
            />
            <div className="vid-titleWrapper">
                <h1 className="vid-title"> 
                    <Typewriter
                        words={[
                            "First Distinctive Company", 
                            "We Build With Excellence", 
                            "Your Vision, Our Mission",
                            "First Distinctive Company"
                        ]}
                        loop={1}
                        cursor
                        cursorStyle="|"
                        typeSpeed={70}
                        deleteSpeed={0}
                        delaySpeed={1500}
                    />
                </h1>

                <div className='vid-dis' data-aos={"fade-up"} data-aos-duration={"400"}>
                    Oil & Gas Services
                </div>
            </div>
            <GasPriceCom />
        </div>
    );
};

export default MainHeaderSec;
